<div>
  <div id="tab_web">
    <!-- 强制修改密码（密码安全策略升级） -->
    <force-change-password
      *ngIf="isNeedChangePassword"
      [defaultOldPassword]="accountPwd"
      (success)="onForceChangePasswordSuccess($event)"
      (close)="onForceChangePasswordClose()"
    ></force-change-password>

    <ng-container *ngIf="!isNeedChangePassword">
      <div class="logo_img_div" (click)="showVersion()">
        <img src="{{assetsRoute}}/picture/learningmap/top_logo_icon.png" alt="" class="" />
      </div>

      <div class="factory_auth_popover" *ngIf="isNeed2FA && signInAccount">
        <div class="popover_content">
          <!-- 标题 -->
          <div class="popover_content_header">
            <p class="title">手机验证</p>
            <div class="close_icon" (click)="closePopover()">×</div>
          </div>

          <div class="popover_content_main">
            <div class="input_wrap" *ngIf="twoFactoryPhone === ''" [ngStyle]="{'border-color':  phoneNumberInvalidTips ? '#f96678' : '#F0F0F0'}">
              <input type="text" placeholder="请输入手机号" autocomplete="off" (blur)="handleFormBlur()" maxlength="14" class="input_text fontSize16" data-target="phone" [(ngModel)]="need2FAPhoneNumber" name="phone" required />
            </div>
            <div style="font-size: 16px; color: #262626" *ngIf="twoFactoryPhone !== ''">已绑定手机号{{need2FAPhoneNumber.substring(0, 3) + '******' + need2FAPhoneNumber.substring(9)}}，请输入验证码验证。</div>
            <div [style.display]="phoneNumberInvalidTips ? 'block':'none'" class="errorTxt phoneValidateTxt" style="padding-left: 5px">请填写正确的手机号码</div>
            <div class="input_wrap" [ngStyle]="{'border-color':  phoneVerCodeInvalidTips || preventFrequencyTips ? '#f96678' : '#F0F0F0'}">
              <input type="text" placeholder="请输入验证码" autocomplete="off" (change)="handleFormBlur()" maxlength="6" class="input_text fontSize16" data-target="smsCode" [(ngModel)]="phoneVerCode" name="verification_code" required />
              <span [style.background] ="canSendCode ? '#495AFF':'#A8BAFF'" class="fontSize14 send_out_btn" (click)="getVerCode(true)">
            <span class="send_out_word">{{ phoneVerCodeStateTxt }}</span>
            <span class="remainTime">{{ phoneVerCodeRemainSeconds }}</span>
          </span>
            </div>
            <div [style.display]="phoneVerCodeInvalidTips ? 'block':'none'" class="errorTxt smsCodeValidateTxt">请填写手机验证码</div>
            <div [style.display]="preventFrequencyTips ? 'block':'none'" class="errorTxt smsCodeValidateTxt">请等待倒计时结束再发送</div>
            <div class="input_wrap captcha_wrap" *ngIf="!isAICoach">
              <input type="text" placeholder="请输入验证码" autocomplete="off" maxlength="8" (blur)="handleFormBlur()" class="input_text fontSize16 captcha_input" [(ngModel)]="captchaCode" name="twoFaCaptchaCode" required />
              <img *ngIf="captchaImageUrl" class="captcha_img" [src]="captchaImageUrl" alt="验证码" title="点击刷新" (click)="refreshCaptcha()" />
            </div>
            <div [style.display]="captchaInvalidTips ? 'block' : 'none'" class="errorTxt">请输入验证码</div>
          </div>

          <!--按钮-->
          <div class="popover_content_control">
            <div class="control_btn" (click)="closePopover()">取消</div>
            <div class="control_btn confirm" (click)="confirm2FA()">完成</div>
          </div>

        </div>
      </div>
      <!-- 手机号码登录 -->
     <div class="signInform signInPhone" *ngIf="signInPhone">
        <div class="tab_word fontSize12 lineHeight24" id="title_3">
        </div>
        <div id="tab_1_Phone" class="input_wrap">
          <input type="text" placeholder="请输入手机号" autocomplete="off" (blur)="handleFormBlur()" maxlength="14" class="input_text fontSize16" data-target="phone" id="tab_1_Phone_input" [(ngModel)]="phoneNumber" name="phone" required />
        </div>
        <div [style.display]="phoneNumberInvalidTips ? 'block':'none'" class="errorTxt phoneValidateTxt">请填写正确的手机号码</div>
        <div id="tab_1_verification" class="input_wrap">
          <input type="text" placeholder="请输入验证码" autocomplete="off" (change)="handleFormBlur()" maxlength="6" class="input_text fontSize16" id="tab_1_verification_input" data-target="smsCode" [(ngModel)]="phoneVerCode" name="verification_code" required />
          <span id="tab_1_verification_send_out" [ngStyle]="{'line-height': isHarmonyOS ? '44px' : '0.7rem', 'height': isHarmonyOS ? '' : '0.7rem', 'padding': isHarmonyOS ? '' : '0.1rem 0.2rem', 'display': isHarmonyOS ? 'inline-block' : ''}" [style.color]="canSendCode ? '#a4a9c0':'#ffe258'" class="fontSize14 send_out" (click)="getVerCode(true)">
            <span class="send_out_word" id="tab_1_verification_send_out_word">{{ phoneVerCodeStateTxt }}</span>
            <span class="remainTime" id="tab_1_verification_send_out_remain_time">{{ phoneVerCodeRemainSeconds }}</span>
          </span>
        </div>
        <div [style.display]="phoneVerCodeInvalidTips ? 'block':'none'" class="errorTxt smsCodeValidateTxt">请填写手机验证码</div>
        <div [style.display]="preventFrequencyTips ? 'block':'none'" class="errorTxt smsCodeValidateTxt">请等待倒计时结束再发送</div>
        <div class="input_wrap captcha_wrap" *ngIf="!isAICoach">
          <input type="text" placeholder="请输入验证码" autocomplete="off" maxlength="8" (blur)="handleFormBlur()" class="input_text fontSize16 captcha_input" [(ngModel)]="captchaCode" name="phoneCaptchaCode" required />
          <img *ngIf="captchaImageUrl" class="captcha_img" [src]="captchaImageUrl" alt="验证码" title="点击刷新" (click)="refreshCaptcha()" />
        </div>
        <div [style.display]="captchaInvalidTips ? 'block' : 'none'" class="errorTxt">请输入验证码</div>
        <div class="privacy">
          <input  type="checkbox" name="" id="checkPhone" (click)="check()" >
          <span class="fontSize12" style="color: rgb(151,151,151);" >我已阅读并同意</span>
          <a href="https://terms.transtalent.cn/" target="_blank" class="fontSize12" >《使用条款》</a>
          <span class="fontSize12" style="color: rgb(151,151,151);" >和</span>
          <a href="https://oss.transtalent.cn/" target="_blank" class="fontSize12" >《隐私政策》</a>
        </div>
        <button [style.backgroundColor]="phoneLoginDisabled ? '#d1d6e3': ''" [disabled]="phoneLoginDisabled" class="submitBtn_3 fontSize16 lineHeight24" (click)="handlePhoneOrAccountLogin()">登&nbsp;&nbsp;录

          <i [style.display]="phoneLoginDisabled? 'inline-block' : 'none'" class="fa fa-spinner spinner"></i>
        </button>
        <div class="tab_word2 fontSize12 lineHeight24" *ngIf="!isAccountLogin"><span (click)="switchLoginType()">使用账号登录 ></span></div>
      </div>
      <!-- 账号登录 -->
      <div class="signInform signInNumber" *ngIf="signInAccount">
        <div class="tab_word fontSize12 lineHeight24" id="title_3">
          如公司已购买账户，请登陆
        </div>
        <div id="tab_1_Number" class="input_wrap">
          <input type="text" placeholder="请输入账号" autocomplete="off" maxlength="256" (blur)="handleFormBlur()" class="input_text fontSize16" data-target="Number" id="tab_1_Number_input" [(ngModel)]="accountName" name="Number" required />
        </div>
        <div [style.display]="accountNameInvalidTips ? 'block' : 'none'" class="errorTxt NumberValidateTxt">请填写账号</div>
        <div id="tab_1_Pwd" class="input_wrap">
          <input type="password" placeholder="请输入密码" autocomplete="off" maxlength="200" (blur)="handleFormBlur()" class="input_text fontSize16" id="tab_1_Pwd_input" data-target="smsPwd" [(ngModel)]="accountPwd" name="verification_Pwd" required />
        </div>
        <div [style.display]="accountPwdInvalidTips ? 'block' : 'none'" class="errorTxt PwdTxt">请填写账号密码</div>
        <div class="input_wrap captcha_wrap" *ngIf="!isAICoach">
          <input type="text" placeholder="请输入验证码" autocomplete="off" maxlength="8" (blur)="handleFormBlur()" class="input_text fontSize16 captcha_input" [(ngModel)]="captchaCode" name="accountCaptchaCode" required />
          <img *ngIf="captchaImageUrl" class="captcha_img" [src]="captchaImageUrl" alt="验证码" title="点击刷新" (click)="refreshCaptcha()" />
        </div>
        <div [style.display]="captchaInvalidTips ? 'block' : 'none'" class="errorTxt">请输入验证码</div>
        <div class="privacy">
          <input  type="checkbox" name="" id="checkUser" (click)="check()" >
          <span class="fontSize12" style="color: rgb(151,151,151);" >我已阅读并同意</span>
          <a href="https://terms.transtalent.cn/" target="_blank" class="fontSize12" >《使用条款》</a>
          <span class="fontSize12" style="color: rgb(151,151,151);" >和</span>
          <a href="https://oss.transtalent.cn/" target="_blank" class="fontSize12" >《隐私政策》</a>
        </div>
        <button [style.backgroundColor]="accountLoginDisabled ? '#d1d6e3': ''" [disabled]="accountLoginDisabled" class="submitBtn_3 fontSize16 lineHeight24" (click)="handlePhoneOrAccountLogin()">登&nbsp;&nbsp;录
          <i [style.display]="accountLoginDisabled? 'inline-block' : 'none'" class="fa fa-spinner spinner"></i>
        </button>
        <div class="tab_word2 fontSize12 lineHeight24" *ngIf="!isAccountLogin"><span (click)="switchLoginType()">使用手机号码登录 ></span></div>
      </div>
    </ng-container>
  </div>
  <div id="message-box"  [ngClass]="{open:messageBoxOpen,fontSize14:true}">{{ tipMessage }}</div>
</div>



// WEBPACK FOOTER //
// ./src/app/new-app-login/new-app-login.component.html